import { __assign } from "tslib";
import React, { useEffect, useState, useMemo, createContext, } from 'react';
import { getCurrentScript } from '../utils/common/getCurrentScript';
import { stringify } from '../utils/polyfills';
function getScriptArgs(scriptId, defaultData, currentScript) {
    if (defaultData === void 0) { defaultData = {}; }
    if (currentScript === void 0) { currentScript = null; }
    var reactScript = currentScript || getCurrentScript(scriptId);
    var data = (reactScript === null || reactScript === void 0 ? void 0 : reactScript.dataset) || [];
    if (Object.keys(data).length > 0) {
        return __assign(__assign({}, data), { id: (reactScript === null || reactScript === void 0 ? void 0 : reactScript.id) ? reactScript.id : '' });
    }
    return defaultData;
}
export var ScriptTagContext = createContext({});
export function ScriptTagProvider(_a) {
    var children = _a.children, scriptId = _a.scriptId, _b = _a.defaultData, defaultData = _b === void 0 ? {} : _b, _c = _a.currentScript, currentScript = _c === void 0 ? null : _c;
    var _d = useState(getScriptArgs(scriptId, defaultData, currentScript)), dataAttrs = _d[0], setDataAttrs = _d[1];
    useEffect(function () {
        setDataAttrs(getScriptArgs(scriptId, defaultData, currentScript));
    }, []);
    var attrs = useMemo(function () { return dataAttrs; }, [stringify(dataAttrs)]);
    return (React.createElement(ScriptTagContext.Provider, { value: attrs }, children));
}
